import React from "react";
import GlassCard from "../../components/GlassCard";
import { useNavigate } from "react-router-dom";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import Warning from "./Warnings";
import { getCurrentConsent } from "../api/intakeApi";
import { beforeFormTranslations } from "../data/beforeFormTranslations";

const BeforeForm = () => {
  const navigate = useNavigate();
  const currentLang = useCurrentLang();
  const t = beforeFormTranslations[currentLang] || beforeFormTranslations.en;

  const goForm = async () => {
    try {
      const result = await getCurrentConsent();
      console.log("result:", result);
      console.log("typeof granted:", typeof result?.granted, result?.granted);

      navigate(
        result?.granted === false
          ? `/${currentLang}/platform/health_consent`
          : `/${currentLang}/platform/form`
      );
    } catch (error) {
      console.error("Failed to fetch consent:", error);
      navigate(`/${currentLang}/platform/health_consent`);
    }
  };

  return (
    <div className="main-platform-shell">
      <GlassCard
        style={{
          padding: "10px",
          maxWidth: "775px",
          marginLeft: "50px",
          marginBottom: "25px",
        }}
      >
        <div
          style={{
            fontSize: "0.8rem",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            opacity: 0.7,
          }}
        >
          {t.platformLabel}
        </div>
        <h1>{t.welcomeTitle}</h1>
        <p>{t.welcomeDescription}</p>
      </GlassCard>

      <GlassCard style={{ padding: "10px", maxWidth: "775px", marginLeft: "50px" }}>
        <div
          style={{
            fontSize: "0.8rem",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            opacity: 0.7,
          }}
        >
          {t.requiredLabel}
        </div>
        <h2>{t.intakeTitle}</h2>
        <p>{t.intakeDescription}</p>
        <h1></h1>
        <h2>{t.physioTitle}</h2>
        <p>{t.physioDescription}</p>
      </GlassCard>

      <GlassCard
        style={{
          padding: "20px",
          borderRadius: "24px",
          marginTop: "24px",
          marginLeft: "50px",
          marginBottom: "24px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 16,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            <div
              style={{
                fontWeight: 700,
                fontSize: 20,
                marginBottom: 4,
              }}
            >
              {t.prePlanTitle}
            </div>
          </div>
          <button
            style={{
              padding: "12px 26px",
              borderRadius: 999,
              backgroundColor: "#176B87",
              color: "white",
              fontWeight: 600,
            }}
            onClick={goForm}
          >
            {t.prePlanButton}
          </button>
        </div>
      </GlassCard>

      <GlassCard
        style={{
          padding: "20px",
          borderRadius: "24px",
          marginTop: "24px",
          marginLeft: "50px",
          marginBottom: "24px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 16,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            <div
              style={{
                fontWeight: 700,
                fontSize: 20,
                marginBottom: 4,
              }}
            >
              {t.customPlanTitle}
            </div>
          </div>
          <input
            type="text"
            style={{
              background: "#EEF5FF",
              width: "200px",
              height: "35px",
              borderRadius: "10px",
              paddingLeft: "10px",
              borderColor: "#176B87",
            }}
            placeholder={t.customPlanPlaceholder}
          />
          {/** connect this to the db!!!!!! */}
        </div>
      </GlassCard>

      <Warning warningType="MissingPersonalInfo" />
    </div>
  );
};

export default BeforeForm;